import type { SVGProps } from 'react';

export default function CalendarQuestion(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 6.75H6.75C5.64543 6.75 4.75 7.64543 4.75 8.75V17.25C4.75 18.3546 5.64543 19.25 6.75 19.25H13.2M8 6.75H16M8 6.75V4.75M8 6.75V8.25M16 6.75H17.25C18.3546 6.75 19.25 7.64543 19.25 8.75V11.25M16 6.75V4.75M16 6.75V8.25M7.75 10.75H16.25M16.6998 13.8818C17.2816 13.3728 18.2248 13.3728 18.8066 13.8818C19.3883 14.3908 19.3883 15.2161 18.8066 15.7252C18.7053 15.8138 18.5931 15.8869 18.4738 15.9447C18.1035 16.1239 17.7532 16.4404 17.7532 16.8518V17.2242M17.7531 19.2138H17.7568V19.2175H17.7531V19.2138Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
